import { render, staticRenderFns } from "./WorkspaceDetails.vue?vue&type=template&id=42aa8b32&"
import script from "./WorkspaceDetails.vue?vue&type=script&lang=js&"
export * from "./WorkspaceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports